export default __webpack_public_path__ + "static/media/Roboto-Bold.c13d0c4f.ttf";